import { render } from "./SelectSugerencia.vue?vue&type=template&id=9fd6b6bc&scoped=true"
import script from "./SelectSugerencia.vue?vue&type=script&lang=js"
export * from "./SelectSugerencia.vue?vue&type=script&lang=js"

import "./SelectSugerencia.vue?vue&type=style&index=0&id=9fd6b6bc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fd6b6bc"]])

export default __exports__